module.exports = __webpack_public_path__ + "assets_app/img/key_0.0a11341a.svg";